'use client';

import React, { useContext, useMemo, useState } from 'react';
import { CollectionType, ProductType } from '@/@types';
import AddToCollection from '../core/components/organism/add-to-collection';
import { useDownloadApp } from '../core/components/organism/download-app-modal/download-app-modal';
import { useUser } from './user';

// eslint-disable-next-line no-unused-vars
const Context = React.createContext<{ addToCollection: (product: ProductType, collection?: CollectionType) => any }>({
  addToCollection: () => {},
});

export const AddCollectionContext: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [values, setValues] = useState<{
    product?: ProductType;
    collection?: CollectionType;
  }>({});
  const downloadApp = useDownloadApp();
  const { isLogged } = useUser();
  const value = useMemo(() => {
    return {
      addToCollection: (product: ProductType, collection?: CollectionType) => {
        if (!isLogged) {
          downloadApp('bookmark');
        }
        setValues({ product, collection });
      },
    };
  }, [isLogged, downloadApp]);
  return (
    <Context.Provider value={value}>
      {children}
      <AddToCollection
        open={!!values.product}
        onClose={() => {
          setValues({});
        }}
        productId={values.product?.id}
        collection={values.collection}
      />
    </Context.Provider>
  );
};

export const useAddCollectionContext = () => {
  return useContext(Context);
};
